import { NgModule, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppLoadService } from './app-load.service';

export function get_settings(appLoadService: AppLoadService) {
    return () => appLoadService.getSettings();
}

@NgModule({ imports: [], providers: [AppLoadService, { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppLoadService], multi: true }, provideHttpClient(withInterceptorsFromDi())] })
export class AppLoadModule {}
